import Swiper, { Navigation } from "swiper";

const setTopSlider = () => {
  const targets = document.querySelectorAll('.js-top-slider');
  if (!targets.length) return false;

  // 基準幅スケーリング
  const basePx = (px, baseWidth = 960) => {
    return window.innerWidth * (px / baseWidth);
  };

  targets.forEach(target => {
    const slides = target.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    const parent = target.closest('.content'),
      prev = parent.querySelector('.nav-swiper__prev'),
      next = parent.querySelector('.nav-swiper__next');

    let swiper = null;
    let enabled = false;

    const getMaxWidth = (space) => {
      const slideWidth = slides[0].clientWidth;
      return (slideWidth * slides.length) + ((slides.length - 1) * space);
    };

    const isEnable = (space) => {
      return target.clientWidth < getMaxWidth(space);
    };

    const init = (space) => {
      if (enabled) return;

      swiper = new Swiper(target, {
        modules: [Navigation],
        // loop: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: space,
        speed: 400,
        navigation: {
          prevEl: prev,
          nextEl: next,
        }
      });

      prev?.classList.add('is-show');
      next?.classList.add('is-show');

      target.classList.remove('slide-none');
      enabled = true;
    };

    // 破棄
    const destroy = () => {
      target.classList.add('slide-none');

      if (!enabled || !swiper) return;

      prev?.classList.remove('is-show');
      next?.classList.remove('is-show');

      swiper.destroy(true, true);
      swiper = null;
      enabled = false;
    };

    const update = () => {
      const space = basePx(20);

      if (isEnable(space)) {
        init(space);

        if (swiper && swiper.params.spaceBetween !== space) {
          swiper.params.spaceBetween = space;
          swiper.update();
        }
      } else {
        destroy();
      }

      target.classList.add('is-init');
    };

    update();

    let rafId = null;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    });
  });
};

export default setTopSlider;